import service from '@/services/onboarding';

export default {
  loadThemes: ({ commit }) => {
    commit('setThemesLoading', true);
    return service.getThemes().then(res => {
      const payload = {
        list: res.filter(theme => !theme.main),
        main: res.find(theme => theme.main),
        selected: res[0],
        type: 'main',
        loading: false,
      };
      commit('setThemes', payload);
    });
  },
  setThemes: ({ commit }, payload) => {
    commit('setThemes', payload);
  },
  finishOnboarding: () => {
    return service.finishOnboarding();
  },
  updateOnboarding: ({ _ }, payload) => {
    return service.updateOnboarding(payload);
  },
  installWidgets: ({ _ }, payload) => {
    return service.installWidgets(payload);
  },
  checkOnboarding: ({ _ }, themeId) => {
    return service.checkOnboarding(themeId);
  },
  uninstallWidgets: ({ _ }, themeId) => {
    return service.uninstallWidgets(themeId);
  },
  checkThemeInstallStatus: ({ _ }, themeId) => {
    return service.checkThemeInstallStatus(themeId);
  },
  setShownWidgetInstallationMessage: () => {
    return service.setShownWidgetInstallationMessage();
  },
};
